import React from "react";
import styled from "styled-components";
import { FaUser, FaTachometerAlt, FaBook } from "react-icons/fa"; // Change the icon here

// Styled components
const Card = styled.div`
  padding: 16px;
  margin: 16px;
  display: flex;
  justify-content: center; // center items horizontally
  align-items: center; // center items vertically
  gap: 16px; // provide spacing between items
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px; // spacing between icon and label
`;

const Label = styled.span`
  font-weight: bold;
`;

function AccountInfo({ accountInfoData }) {
  if (!accountInfoData) {
    return null;
  }

  return (
    <div className="card">
      <Card>
        <InfoItem>
          <FaUser size={24} />
          <Label>Customer Name:</Label> {accountInfoData.CustomerName || "N/A"}
        </InfoItem>

        <InfoItem>
          <FaTachometerAlt size={24} />
          <Label>Account Level:</Label> {accountInfoData.AccountLevel || "N/A"}
        </InfoItem>

        <InfoItem>
          <FaBook size={24} />
          <Label>Account Title:</Label> {accountInfoData.AccountTitle || "N/A"}
        </InfoItem>

        <InfoItem>
          <FaBook size={24} />
          <Label>Account Status:</Label>{" "}
          {accountInfoData.AccountStatus || "N/A"}
        </InfoItem>
      </Card>
    </div>
  );
}

export default AccountInfo;
